import * as Yup from 'yup'

export const expertsListingSchemaValidation = Yup.object().shape({
  content: Yup.object().shape({
    isFilterEnabled: Yup.boolean(),
  }),
})
